import { Dialog, DialogContent } from '@mui/material'

import { DialogHeader } from '@/components/atoms/DialogHeader'
import { NOTION_DIALOG_PAPER_SX } from '@/shared/styles/dialogStyles'

import type { NutritionCustomer } from './api'
import { NutritionCustomerPanel } from './NutritionCustomerPanel'

interface Props {
  open: boolean
  customer: NutritionCustomer
  onClose: () => void
}

// お客様の情報 (4 欄と患者 ID)。カルテの ⋯ から開く (design-book ADR-0084)。直すのはたまにで、カルテの面に常に並べる
// ほどではない。欄を離れた時点で保存する (保存の釦を持たない)。閉じる前に focus を外し、打ちかけの欄も保存する
// (Esc や背景で閉じると blur が起きない)。
export const NutritionCustomerDialog = ({ open, customer, onClose }: Props) => {
  const close = () => {
    if (document.activeElement instanceof HTMLElement)
      document.activeElement.blur()
    onClose()
  }
  return (
    <Dialog
      open={open}
      onClose={close}
      maxWidth="sm"
      fullWidth
      sx={{ '& .MuiDialog-paper': NOTION_DIALOG_PAPER_SX }}
    >
      <DialogHeader title="お客様の情報" onClose={close} />
      <DialogContent sx={{ pt: 2, pb: 3 }}>
        <NutritionCustomerPanel customer={customer} />
      </DialogContent>
    </Dialog>
  )
}
